import React from "react";
import { InstallerLogin } from "../../components/installer/InstallerLogin";

export function withInstallerAuthentication(WrappedComponent: React.ComponentType) {
    return class extends React.PureComponent<
        unknown,
        {
            isAuthenticated: boolean;
        }
    > {
        constructor(props: unknown) {
            super(props);
            this.state = {
                isAuthenticated: false,
            };
        }
        componentDidMount() {
            const authToken = localStorage.getItem("accessToken");
            const role = localStorage.getItem("userRole");
            if (authToken && role === "installer") {
                this.setState({ isAuthenticated: true });
            }
        }

        // Stable callback references to prevent recreation on every render
        private handleLoginSuccess = () => {
            this.setState({ isAuthenticated: true });
        };

        private handleLoginError = () => {
            this.setState({ isAuthenticated: false });
        };

        render() {
            return this.state.isAuthenticated ? (
                <WrappedComponent {...this.props} />
            ) : (
                <InstallerLogin onLoginSuccess={this.handleLoginSuccess} onLoginError={this.handleLoginError} />
            );
        }
    };
}
